import { useEffect, useState } from "react";
import { createHomeSlider, type HomeSlider } from "../../../types/HomeSlider";
import { useLoadingStore } from "../../../store/loadingStore";
import Sliders from "../../../components/Config/HomeConfig/Sliders/Sliders";
import { executeDelete, executeFetch, executePost, executePostForm, executePutForm } from "../../../helper/Api";
import { Exception } from "sass";
import useToastStore from "../../../store/toastStore";
import BrandBanners from "../../../components/Config/HomeConfig/BrandBanners/BrandBanners";
import { HomeBrandBanner } from "../../../types/HomeBrandBanner";
import BrandLogos from "../../../components/Config/ProductsConfig/BrandLogos/BrandLogos";
import { Brands } from "../../../types/Brands";

export default function ProductsBrandLogos() {
    // States
    const [brands, setBrands] = useState<HomeBrandBanner[]>([]);
    const {setLoading} = useLoadingStore();
    const {showToast} = useToastStore();

    //Actions
   


    const handleUpdateBrand = (updatedBrand: Brands) => {
      setBrands(brands.map(brand => 
        brand.id === updatedBrand.id ? updatedBrand : brand
      ));
    };

    const getFileNameFromUrl = (url: string) => {
      const urlParts = url.split('/');
      return urlParts[urlParts.length - 1];
    };

    const handleRemoveBrand = async (brand: Brands) => {
      updateBrand(brand,null)
    };

    const updateBrand= async (brand : Brands, image : File | null) => {
          const payLoad = new FormData();
          payLoad.append('brandLogoString',JSON.stringify(brand));
          payLoad.append('logo',image);
          setLoading(true);
        const updateBrandResult = await executePutForm<HomeSlider>('Settings/UpdateBrandLogo',payLoad,{admin:true});
        if(updateBrandResult.error){
          showToast('Something went wrong updating brand banner!','error')
          console.error(updateBrandResult.error.message);
        }else{
          showToast('Successfully update the brand banner!','success')
          setBrands(prev =>
            prev.map(s => s.id === updateBrandResult.data?.id ? updateBrandResult.data! : s)
          );
        }
        setLoading(false);      
    }

    //Effects

    useEffect(()=>{
      const fetchHomeBrands=async () => {
        setLoading(true);
        //fetch home sliders
        const brandsResp = await executeFetch<Brands[]>('Category/GetBrands');
        if(brandsResp.error){
           console.error(brandsResp.error.message)
        }else{
          const sortedBanners = brandsResp.data.sort((a, b) => a.name.localeCompare(b.name));
          setBrands(sortedBanners);
        }
        setLoading(false);
      }
      fetchHomeBrands();
    },[])


  
    
    return (
        <div className="admin-section product-brand-logos">
        <BrandLogos brands={brands} onUpdate={handleUpdateBrand} updateBrand={updateBrand} onRemove={handleRemoveBrand}/>
        </div>
    );
  };
  
  